//
// Copyright 2021 DXOS.org
//
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_dxos_echo_feed } from "../echo/feed_pb.js";
import { file_dxos_echo_metadata } from "../echo/metadata_pb.js";
import { file_dxos_echo_snapshot } from "../echo/snapshot_pb.js";
import { file_dxos_echo_timeframe } from "../echo/timeframe_pb.js";
import { file_dxos_keys } from "../keys_pb.js";
import { file_dxos_mesh_signal } from "../mesh/signal_pb.js";
/**
 * Describes the file dxos/devtools/host.proto.
 */
export const file_dxos_devtools_host = /*@__PURE__*/ fileDesc("ChhkeG9zL2RldnRvb2xzL2hvc3QucHJvdG8SEmR4b3MuZGV2dG9vbHMuaG9zdCJRChtTdWJzY3JpYmVUb01ldGFkYXRhUmVzcG9uc2USMgoIbWV0YWRhdGEYASABKAsyIC5keG9zLmVjaG8ubWV0YWRhdGEuRWNob01ldGFkYXRhIvMCChlTdWJzY3JpYmVUb1NwYWNlc1Jlc3BvbnNlEkcKBnNwYWNlcxgBIAMoCzI3LmR4b3MuZGV2dG9vbHMuaG9zdC5TdWJzY3JpYmVUb1NwYWNlc1Jlc3BvbnNlLlNwYWNlSW5mbxqMAgoJU3BhY2VJbmZvEiEKA2tleRgBIAEoCzIULmR4b3Mua2V5cy5QdWJsaWNLZXkSDwoHaXNfb3BlbhgCIAEoCBI8Cgl0aW1lZnJhbWUYAyABKAsyJC5keG9zLmVjaG8udGltZWZyYW1lLlRpbWVmcmFtZVZlY3RvckgAiAEBEioKDGdlbmVzaXNfZmVlZBgEIAEoCzIULmR4b3Mua2V5cy5QdWJsaWNLZXkSKgoMY29udHJvbF9mZWVkGAUgASgLMhQuZHhvcy5rZXlzLlB1YmxpY0tleRInCglkYXRhX2ZlZWQYBiABKAsyFC5keG9zLmtleXMuUHVibGljS2V5QgwKCl90aW1lZnJhbWUi0QEKHVN1YnNjcmliZVRvRmVlZEJsb2Nrc1Jlc3BvbnNlEkcKBmJsb2NrcxgBIAMoCzI3LmR4b3MuZGV2dG9vbHMuaG9zdC5TdWJzY3JpYmVUb0ZlZWRCbG9ja3NSZXNwb25zZS5CbG9jaxpnCgVCbG9jaxImCghmZWVkX2tleRgBIAEoCzIULmR4b3Mua2V5cy5QdWJsaWNLZXkSCwoDc2VxGAIgASgFEikKBGRhdGEYAyABKAsyGy5keG9zLmVjaG8uZmVlZC5GZWVkTWVzc2FnZSJhChhHZXRTcGFjZVNuYXBzaG90UmVzcG9uc2USOAoIc25hcHNob3QYASABKAsyIS5keG9zLmVjaG8uc25hcHNob3QuU3BhY2VTbmFwc2hvdEgAiAEBQgsKCV9zbmFwc2hvdCJiChlTYXZlU3BhY2VTbmFwc2hvdFJlc3BvbnNlEjgKCHNuYXBzaG90GAEgASgLMiEuZHhvcy5lY2hvLnNuYXBzaG90LlNwYWNlU25hcHNob3RIAIgBAUILCglfc25hcHNob3QiygEKDlNpZ25hbFJlc3BvbnNlEjMKC3N3YXJtX2V2ZW50GAEgASgLMhwuZHhvcy5tZXNoLnNpZ25hbC5Td2FybUV2ZW50SAASLAoHbWVzc2FnZRgCIAEoCzIZLmR4b3MubWVzaC5zaWduYWwuTWVzc2FnZUgAEi8KC3JlY2VpdmVkX2F0GAMgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBISCgV0b3BpYxgEIAEoDEgBiAEBQgYKBGRhdGFCCAoGX3RvcGljYgZwcm90bzM", [file_google_protobuf_timestamp, file_dxos_echo_feed, file_dxos_echo_metadata, file_dxos_echo_snapshot, file_dxos_echo_timeframe, file_dxos_keys, file_dxos_mesh_signal]);
/**
 * Describes the message dxos.devtools.host.SubscribeToMetadataResponse.
 * Use `create(SubscribeToMetadataResponseSchema)` to create a new message.
 */
export const SubscribeToMetadataResponseSchema = /*@__PURE__*/ messageDesc(file_dxos_devtools_host, 0);
/**
 * Describes the message dxos.devtools.host.SubscribeToSpacesResponse.
 * Use `create(SubscribeToSpacesResponseSchema)` to create a new message.
 */
export const SubscribeToSpacesResponseSchema = /*@__PURE__*/ messageDesc(file_dxos_devtools_host, 1);
/**
 * Describes the message dxos.devtools.host.SubscribeToSpacesResponse.SpaceInfo.
 * Use `create(SubscribeToSpacesResponse_SpaceInfoSchema)` to create a new message.
 */
export const SubscribeToSpacesResponse_SpaceInfoSchema = /*@__PURE__*/ messageDesc(file_dxos_devtools_host, 1, 0);
/**
 * Describes the message dxos.devtools.host.SubscribeToFeedBlocksResponse.
 * Use `create(SubscribeToFeedBlocksResponseSchema)` to create a new message.
 */
export const SubscribeToFeedBlocksResponseSchema = /*@__PURE__*/ messageDesc(file_dxos_devtools_host, 2);
/**
 * Describes the message dxos.devtools.host.SubscribeToFeedBlocksResponse.Block.
 * Use `create(SubscribeToFeedBlocksResponse_BlockSchema)` to create a new message.
 */
export const SubscribeToFeedBlocksResponse_BlockSchema = /*@__PURE__*/ messageDesc(file_dxos_devtools_host, 2, 0);
/**
 * Describes the message dxos.devtools.host.GetSpaceSnapshotResponse.
 * Use `create(GetSpaceSnapshotResponseSchema)` to create a new message.
 */
export const GetSpaceSnapshotResponseSchema = /*@__PURE__*/ messageDesc(file_dxos_devtools_host, 3);
/**
 * Describes the message dxos.devtools.host.SaveSpaceSnapshotResponse.
 * Use `create(SaveSpaceSnapshotResponseSchema)` to create a new message.
 */
export const SaveSpaceSnapshotResponseSchema = /*@__PURE__*/ messageDesc(file_dxos_devtools_host, 4);
/**
 * Describes the message dxos.devtools.host.SignalResponse.
 * Use `create(SignalResponseSchema)` to create a new message.
 */
export const SignalResponseSchema = /*@__PURE__*/ messageDesc(file_dxos_devtools_host, 5);
//# sourceMappingURL=host_pb.js.map